<template>
  <div class="myorders">
    <mainmenu selected="report-orders"></mainmenu>
    <div class="container-fluid">
      <h1>{{$t('report_unordered_products.page_title')}}</h1>
        <el-card class="box-card">
            <div>
                <a :href="$http.options.root + 'report_unordered_articles/export_excel'" target="_blank" class="el-button pull-right el-button--success"> 
                    {{$t('report_unordered_products.export_to_excel')}}
                </a>
            </div>
        </el-card>

        <el-table :data="Results" style="width: 100%; margin-top: 50px" v-loading="tableLoadingVisible">
            <el-table-column prop="FactoryCode" :label="$t('report_unordered_products.factory_code')" width="100"></el-table-column>

            <el-table-column prop="ArticleNumber" :label="$t('report_unordered_products.article_number')" width="200"></el-table-column>
            <el-table-column prop="ProductName" :label="$t('report_unordered_products.product_name')" ></el-table-column>

            <el-table-column prop="FirstUploadDate" :label="$t('report_unordered_products.first_upload_date')" width="200"></el-table-column>

            <el-table-column prop="CurrentQuantity" :label="$t('report_unordered_products.current_quantity')" width="180"></el-table-column>
            <el-table-column prop="OrderedQuantity" :label="$t('report_unordered_products.ordered_quantity')" width="180"></el-table-column>
        </el-table>

    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";
import moment from 'moment';

export default {
  name: "report-unordered-articles",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: []
    }
  },
  methods: {
    
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('report_unordered_articles/refresh_info',  {} )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
            } else {
              this.$router.push("/");
            }
          }); 
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>
  .el-form-item__label{
    display: block;
    float: none !important;
  }
  .button-link{
    text-decoration: none;
  }
  .full-width{
    width: 100% !important;
  }
</style>